import { style } from "typestyle";

export const labelCN = style({
  fontSize: "16px",
  lineHeight: "24px",
  color: "rgba(0,0,0,0.87)",
  marginBottom: "4px",
});
